import { useNavigate } from "react-router";
import DatePicker from "react-datepicker";

const MonthPicker = ({ loading, date, setDate, onSubmit }) => {
    const navigate = useNavigate();
    const handleClick = () => {


        navigate(`?date=${date}`);
        onSubmit()
    };
    return (
        <>
            <div
                className="flex items-center flex-wrap gap-3  justify-center"

            >

                <DatePicker
                    selected={date}
                    onChange={(dt) => setDate(dt)}
                    dateFormat="MM/yyyy" // Display format
                    showMonthYearPicker // Enables month and year selection
                    showFullMonthYearPicker // Full month and year selection view
                    className="bg-white gap-2 rounded-[5px] py-[10px] px-[15px] "

                />
                {loading ?
                    <button className="px-[15px] flex items-center justify-center py-[10px] w-[100px] bg-ternary text-sm font-[400] rounded-2xl">
                        <span>
                            <svg
                                className="animate-spin"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    opacity="0.5"
                                    cx="10"
                                    cy="10"
                                    r="9"
                                    stroke="white"
                                    stroke-width="2"
                                />
                                <mask id="path-2-inside-1_2527_20936" fill="white">
                                    <path d="M18.4713 13.0345C18.9921 13.221 19.5707 12.9508 19.7043 12.414C20.0052 11.2042 20.078 9.94582 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.6285 0.597723 12.4262 0.219019 11.1884 0.0708647C10.6392 0.00512742 10.1811 0.450137 10.1706 1.00319C10.1601 1.55625 10.6018 2.00666 11.1492 2.08616C12.0689 2.21971 12.9609 2.51295 13.7841 2.95511C14.9023 3.55575 15.8615 4.41394 16.5823 5.45872C17.3031 6.50351 17.7649 7.70487 17.9294 8.96348C18.0505 9.89002 18.008 10.828 17.8063 11.7352C17.6863 12.2751 17.9506 12.848 18.4713 13.0345Z" />
                                </mask>
                                <path
                                    d="M18.4713 13.0345C18.9921 13.221 19.5707 12.9508 19.7043 12.414C20.0052 11.2042 20.078 9.94582 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.6285 0.597723 12.4262 0.219019 11.1884 0.0708647C10.6392 0.00512742 10.1811 0.450137 10.1706 1.00319C10.1601 1.55625 10.6018 2.00666 11.1492 2.08616C12.0689 2.21971 12.9609 2.51295 13.7841 2.95511C14.9023 3.55575 15.8615 4.41394 16.5823 5.45872C17.3031 6.50351 17.7649 7.70487 17.9294 8.96348C18.0505 9.89002 18.008 10.828 17.8063 11.7352C17.6863 12.2751 17.9506 12.848 18.4713 13.0345Z"
                                    stroke="white"
                                    stroke-width="4"
                                    mask="url(#path-2-inside-1_2527_20936)"
                                />
                            </svg>
                        </span>
                    </button>
                    :
                    <button onClick={handleClick} className="px-[15px] py-[10px] w-[100px] bg-ternary text-sm font-[400] rounded-2xl">Submit</button>}

            </div>
        </>
    )
}

export default MonthPicker